import React, { useCallback } from 'react'
import { Button } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    width: ({ width }: propTypes) => width,
    marginTop: ({ mt }: propTypes) => mt,
    marginBottom: ({ mb }: propTypes) => mb,
    marginLeft: ({ ml }: propTypes) => ml,
    marginRight: ({ mr }: propTypes) => mr,

    height: 32,
    padding: '0 14px',

    borderRadius: 4,

    fontSize: 12,
    fontWeight: 500,
    lineHeight: 0,

    opacity: '0.8',
    color: theme.palette.primary.light,
    background: '#C92A2A',
    '&:hover': {
      opacity: 1,
      background: '#C92A2A',
    },
  },
  prefix: {
    fontSize: 18,
    fontWeight: 400,
    paddingRight: 10,
    lineHeight: 0,
  },
  text: {
    textTransform: 'none',
  },
}))

type propTypes = {
  prefix?: string
  text: string
  width: number | string
  mt?: number | string
  mb?: number | string
  ml?: number | string
  mr?: number | string
  type?: string
  href?: string
  onClick?: () => void
}

export const RedButton: React.FC<propTypes> = ({ prefix, text, width, mt, mb, ml, mr, type, href, onClick }) => {
  const classes = useStyles({ prefix, text, width, mt, mb, ml, mr, type, href, onClick })
  const history = useHistory()

  const goTo = useCallback(() => {
    history.push(`${href}`)
  }, [history, href])

  return (
    <Button variant="contained" type="submit" className={classes.button} onClick={href ? goTo : onClick}>
      {prefix && <span className={clsx(classes.prefix, 'material-icons')}>{prefix}</span>}
      <span className={classes.text}>{text}</span>
    </Button>
  )
}
